import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { useLocation } from '@reach/router';
import { PropertiesListingConfigFragment } from '../../../gatsby-graphql';
import { updateOperationTypeInPath } from '../../utils';

interface IOperationTypesSelectorProps {
  operationTypes: PropertiesListingConfigFragment['operationTypes'];
}

const OperationTypesSelector: React.FC<IOperationTypesSelectorProps> = ({
  operationTypes,
}) => {
  const location = useLocation();
  return (
    <OperationTypesContainer>
      {operationTypes?.map((operationType) => (
        <Link
          partiallyActive={true}
          activeClassName="active"
          key={operationType?.slug}
          to={updateOperationTypeInPath(location.pathname, operationType?.slug)}
        >
          {operationType?.name}
        </Link>
      ))}
    </OperationTypesContainer>
  );
};

const OperationTypesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  a {
    font-size: 14px;
    line-height: 17px;
    color: ${(props) => props.theme.colors.dark.primary};
    font-weight: bold;
    text-decoration: none;
    ${(props) => props.theme.mq.desktop} {
      font-size: 16px;
      line-height: 19px;
    }
    &.active {
      color: ${(props) => props.theme.colors.primary};
    }
    &:hover {
      text-decoration: underline;
    }
  }
`;

export default React.memo(OperationTypesSelector);
